import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0,300px))',
    gap: 16,
    height: 110,
  },
  rootWithEmail: {
    gridTemplateColumns: '110px repeat(3, minmax(0,300px))',
  },
  stepWrapper: {
    boxSizing: 'border-box',
    backgroundColor: primary.bluish8,
    borderRadius: 8,
    padding: spacing(4),
    height: '100%',
    opacity: 0.5,
  },
  stepWrapperActive: {
    opacity: 1,
  },
  label: {
    marginBottom: spacing(3),
  },
  stepStatsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emailCount: {
    marginBottom: spacing(2),
  },
  countWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: spacing(2),
  },
  percentage: {
    marginLeft: spacing(6),
  },
}));

const CycleStepsStats = ({
  className = undefined,
  steps = [],
  hasEmailStep = false,
}) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(
        classes.root,
        { [classes.rootWithEmail]: hasEmailStep },
        className
      )}
    >
      {steps.map(step => {
        const { id, name, isActive, isEmailStep, stats } = step;

        return (
          <div
            key={`step_stats_${id}`}
            className={classNames(classes.stepWrapper, {
              [classes.stepWrapperActive]: isActive,
            })}
          >
            <Typography className={classes.label} variant="subtitle1">
              {name}
            </Typography>
            <div
              className={classNames({
                [classes.stepStatsWrapper]: !isEmailStep,
              })}
            >
              <div
                className={classNames({
                  [classes.countWrapper]: !isEmailStep,
                })}
              >
                <Typography
                  className={classNames({
                    [classes.emailCount]: isEmailStep,
                  })}
                  variant="h3"
                >
                  {`${!isEmailStep ? stats.completedUsers : ''} ${
                    !isEmailStep ? '/' : ''
                  } ${stats.totalUsers}`}
                </Typography>
                {!isEmailStep && (
                  <Typography className={classes.percentage} variant="h3">
                    {`${stats.percentage}%`}
                  </Typography>
                )}
              </div>
              <Typography className={classes.statLabel} variant="subtitle2">
                {stats.label}
              </Typography>
            </div>
          </div>
        );
      })}
    </div>
  );
};

CycleStepsStats.propTypes = {
  className: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.object),
  hasEmailStep: PropTypes.bool,
};

export default CycleStepsStats;
